(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-meria-cookie-preferences]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-meria-cookie-status]');
    status.hidden = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      status.hidden = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-meria-password-preferences]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-meria-password-cookie-status]');
    status.hidden = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Unavailable');
      await window.privacyBanner.showPreferences();
    } catch { status.hidden = false; }
  });

  } catch(e) { console.error(e); }
})();
})();
